import React, { memo } from 'react'
import { ApprovalFlowItemModel, ApprovalFlowTypeEnum } from '@/constants/enum'
import styles from '../StaticApprovalFlow/StaticApprovalFlow.module.scss'
import AvatarUser from '../AvatarUser/AvatarUser'
import { useTranslation } from '@/services/i18n'

interface ChildProps {
  items: ApprovalFlowItemModel[] | [] | undefined
}
const StaticApprovalFlow = memo<ChildProps>(props => {
  const { t } = useTranslation()
  const { items } = props
  return (
    <div className={styles.approve_flow}>
      {items?.map((item, index) => {
        return (
          <div className={styles.flow_item} key={index}>
            <div className={styles.step_dot}></div>
            {index < items.length - 1 && <div className={styles.left_line} />}
            {item.type === ApprovalFlowTypeEnum.RULE ? (
              <div>
                <header>
                  {item.name} ({item.num}/{item.userDtoList?.length})
                </header>
                <div className={styles.user_list}>
                  {item.userDtoList?.map(user => {
                    return (
                      <div style={{ flex: '50%', marginTop: '10px' }} key={user?.userKey}>
                        <AvatarUser
                          avatar={user.userPortrait}
                          name={user.userName}
                          isDeleted={user.isDeleted}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            ) : index === 0 ? (
              t('common.quickAudit')
            ) : (
              t('common.InitiatorSelf')
            )}
          </div>
        )
      })}
    </div>
  )
})

export default StaticApprovalFlow
